import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ metric }) => {
  const getChangeColor = (type) => {
    return type === 'positive' ? 'text-success' : 'text-error';
  };

  const getChangeIcon = (type) => {
    return type === 'positive' ? 'TrendingUp' : 'TrendingDown';
  };

  return (
    <div className="bg-card rounded-lg p-6 shadow-conservation">
      <div className="flex items-start justify-between mb-4">
        <div className={`${metric?.iconColor} rounded-full p-3`}>
          <Icon name={metric?.icon} size={24} />
        </div>
        <div className={`flex items-center gap-1 ${getChangeColor(metric?.changeType)}`}>
          <Icon name={getChangeIcon(metric?.changeType)} size={16} />
          <span className="text-sm font-medium">{metric?.change}</span>
        </div>
      </div>
      <h3 className="text-sm text-gray-600 dark:text-gray-300 mb-1">{metric?.title}</h3>
      <div className="flex-1">
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-1">{metric?.label}</p>
        <p className="text-2xl font-bold text-gray-900 dark:text-white">{metric?.value}</p>
        {metric?.change && (
          <p className={`text-xs mt-1 flex items-center gap-1 ${
            metric?.trend === 'up' ? 'text-success' :
            metric?.trend === 'down' ? 'text-error' : 'text-gray-900 dark:text-white'
          }`}>
            {metric?.change}
          </p>
        )}
      </div>
      
      {metric?.trend && (
        <div className="mt-4 h-12 flex items-end gap-1">
          {metric?.trend?.map((value, index) => (
            <div
              key={index}
              className="flex-1 bg-primary/20 rounded-t"
              style={{ height: `${(value / Math.max(...metric?.trend)) * 100}%` }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MetricCard;